import { useState, useRef, useEffect } from "react";
const debounce = require("debounce");

function useMasonry() {
    const [items, setMasonryItems] = useState([]);
    const [columns, setColumns] = useState([]);
    const [isMobile, setIsMobile] = useState(
        window.matchMedia("(max-width: 768px)").matches
    );

    const handleResize = () => {
        setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    };

    const buildMasonry = (items, numberOfColumns, columnStartIndex) => {
        let colIndex = columnStartIndex;
        const cols = [];
        for (let i = 0; i < numberOfColumns; i++) {
            cols.push([]);
        }
        items.map((item, i) => {
            cols[colIndex].push(i);
            if (colIndex < numberOfColumns - 1) {
                colIndex += 1;
            } else {
                colIndex = 0;
            }
        });
        setColumns(cols);
    };

    useEffect(() => {
        window.addEventListener(
            "resize",
            debounce(() => {
                handleResize();
            }, 50)
        );
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (!items) return;
        const numberOfColumns = isMobile ? 2 : 3;
        buildMasonry(items, numberOfColumns, 1);
    }, [items, isMobile]);

    return { columns, isMobile, setMasonryItems };
}

export default useMasonry;